// src/features/admin-templates/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import TemplateAdminPage from './pages/TemplateAdminPage';

export const AdminTemplatesRoutes = () => (
  <Route path="admin/templates">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="administration-template:read">
          <TemplateAdminPage />
        </ProtectedRoute>
      }
    />
  </Route>
);
